import DisplayInformation from '../display-information/display-information';
import ProviderService from '../provider-service';

export default {
  supportedProviders: [ProviderService.Hermes, ProviderService.DpdWallet, ProviderService.ParcelforceWallet],
  displayInformation: new DisplayInformation({
    displayName: 'ShipStation Carrier Services',
    name: 'shipstation',
    colorSVG: 'shipstation-color.svg',
    iconColor: 'shipstation-icon-color.svg',
  }),
};
